/** Standard max file size for image/video uploads across the admin panel (10 MB). */
export const MAX_UPLOAD_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_UPLOAD_FILE_MB = 10;

export function isWithinMaxUploadSize(file) {
  const size = file?.size;
  if (size == null || typeof size !== 'number') return true;
  return size <= MAX_UPLOAD_FILE_BYTES;
}

/** Ant Design `beforeUpload`: returns false when the file exceeds the limit. */
export function beforeUploadMaxSize(file, onReject) {
  if (isWithinMaxUploadSize(file)) return true;
  onReject?.(file);
  return false;
}

/** Filter file list items whose underlying File/Blob exceeds the limit. */
export function filterFilesWithinMaxUploadSize(files, onReject) {
  return files.filter((item) => {
    const file = item?.originFileObj ?? (item instanceof File ? item : null);
    if (!file || isWithinMaxUploadSize(file)) return true;
    onReject?.(file);
    return false;
  });
}
